import React from 'react';
import { Container, Title } from './styles';

export default function Header() {
  return (
    <Container>
      <Title>
        Let's plan your <strong>saving goal</strong>.
      </Title>
    </Container>
  );
}
